import { render, staticRenderFns } from "./ComplianceFormDetail.vue?vue&type=template&id=66d81517&"
import script from "./ComplianceFormDetail.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormDetail.vue?vue&type=style&index=0&id=66d81517&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports